import { Avatar, Tooltip } from "@radix-ui/themes";
import { useState } from "react";
import { TbBook2, TbBriefcase, TbBrightnessDown, TbBrightnessUp, TbBuildingWarehouse, TbCalendarCog, TbCpu, TbHeartRateMonitor, TbHelp, TbLogout2, TbMap2, TbNotification, TbReport, TbSettings, TbUser, TbUsersGroup } from "react-icons/tb";

import { Transition, TransitionChild } from '@headlessui/react';
import { t } from "i18next";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import RoleRequire from "../../helpers/auth/RoleRequire";
import DevicesMenu from "../../pages/devices/DevicesMenu";
import DirectoriesMenu from "../../pages/directories/DirectoriesMenu";
import EquipmentsMenu from "../../pages/equipment/EquipmentsMenu";
import MonitoringMenu from "../../pages/monitoring/MonitoringMenu";
import ReportsMenu from "../../pages/reports/ReportsMenu";
import StaffMenu from "../../pages/staff/StaffMenu";
import { useAppStore } from "../../stores/RootStore";
import { useScreenStore } from "../../stores/ScreenStore";
import { useTabsStore } from "../../stores/TabsStore";
import { Popover, PopoverContent, PopoverTrigger } from "../../ui/Popover";
import { Separator } from "../../ui/Separator";
import { FlowCommandMenu } from "../Command/FlowCommandMenu";
import TrackingMenu from "./sidebarMenu/menuModules/TrackingMenu";
import ManagmentMenu from "../../pages/managment/ManagmentMenu";

type Props = {};

function defaultInitials(name = "") {
  return name.split(/\s/)
      .map(part => part.substring(0, 1).toUpperCase())
      .filter(v => !!v)
      .slice(0, 3)
      .join('')
      .toUpperCase();
}

function label(key: string) {
  return t(key) || key;
}

export const MainSidebar = (props: Props) => {
  const store = useAppStore()
  const [openMenu, setOpenMenu] = useState(false)
  const [menu, setMenu] = useState<string | null>(null)
  const navigate = useNavigate();
  const location = useLocation()
  const resetTabsStore = useTabsStore((store) => store.resetStore);
  const resetScreenStore = useScreenStore((store) => store.resetStore);


  function getMenuContent(menu: string | null) {
    switch (menu) {
      case "monitoring": return <MonitoringMenu onClose={closeDrawer}/>
      case "managment": return <ManagmentMenu onClose={closeDrawer}/>
      case "reports": return <ReportsMenu onClose={closeDrawer}/>
      case "tracking": return <TrackingMenu />
      case "devices": return <DevicesMenu onClose={closeDrawer}/>
      case "equipments": return <EquipmentsMenu onClose={closeDrawer}/>
      case "personneles": return <StaffMenu onClose={closeDrawer}/>
      case "directories": return <DirectoriesMenu onClose={closeDrawer}/>
      default:
        break;
    }
  }

  const changeTheme = () => {
    if (document.body.classList.contains("dark")) {
      document.body.classList.remove("dark");
      document.body.classList.add("light");
      store.setTheme("light")
    } else {
      document.body.classList.remove("light");
      document.body.classList.add("dark");
      store.setTheme("dark")
    }
  };

  function openDrawer(point: string) {
    if(point === menu) {
      setOpenMenu(false)
      setMenu(null)
    } else {
      setOpenMenu(true)
      setMenu(point)
    }
  }

  function closeDrawer() {
    setOpenMenu(false)
    setMenu(null)
  }

  const signout = () => {
    if (typeof window !== "undefined") {
      resetTabsStore();
      resetScreenStore();

      localStorage.removeItem("weld-jwt");
      navigate("/");

      return fetch("/users/sessions", {
        method: "DELETE",
      })
        .then((response) => {
          store.resetStore();
        })
        .catch((err) => console.log(err));
    }
  };

  function handleClickMaintenance() {
    setMenu('repair_and_service')
    closeDrawer()
    navigate("/maintenance")
  }

  return (
    <>
      <FlowCommandMenu />
      <div className="flex flex-col w-14 bg-background h-full relative z-20">
        <div className="flex-none flex p-2 items-center ">
          <Avatar
            size="3"
            src={store.currentSite?.image?.attributes?.filename}
            fallback={defaultInitials(store.currentSite?.name!)}
          />
        </div>
        <div className="flex flex-col h-full justify-between">
          <div className="flex flex-col h-full">
            <div className="flex flex-col w-14 py-2 gap-2">
              <button aria-label={label('monitoring')} className="flex items-center justify-center p-0" onClick={() => openDrawer("monitoring")}>
                <Tooltip content={t('monitoring')} delayDuration={50} side="right" sideOffset={10} className="bg-muted">
                  <div
                    className={`flex items-center justify-center p-2.5 rounded hover:bg-border hover:text-primary ${
                      menu === "monitoring" ? "bg-border text-primary" : "text-foreground"
                    }`}
                  >
                    <TbHeartRateMonitor className="w-5 h-5" />
                  </div>
                </Tooltip>
              </button>
              <button aria-label={label('managment')} className="flex items-center justify-center p-0" onClick={() => openDrawer("managment")}>
                <Tooltip content={t('managment')} delayDuration={50} side="right" sideOffset={10} className="bg-muted">
                  <div
                    className={`flex items-center justify-center p-2.5 rounded hover:bg-border hover:text-primary ${
                      menu === "managment" ? "bg-border text-primary" : "text-foreground"
                    }`}
                  >
                    <TbBriefcase className="w-5 h-5" />
                  </div>
                </Tooltip>
              </button>
              <button aria-label={label('analytic')} className="flex items-center justify-center p-0" onClick={() => openDrawer("reports")}>
                <Tooltip content={t('analytic')} delayDuration={50} side="right" sideOffset={10} className="bg-muted">
                  <div
                    className={`flex items-center justify-center p-2.5 rounded hover:bg-border hover:text-primary ${
                      menu === "reports" ? "bg-border text-primary" : "text-foreground"
                    }`}
                  >
                    <TbReport className="w-5 h-5" />
                  </div>
                </Tooltip>
              </button>
              {/* <button className="flex items-center justify-center p-0" onClick={() => openDrawer("tracking")}>
                <Tooltip content={t('tracking')} delayDuration={50} side="right" sideOffset={10} className="bg-muted">
                  <div
                    className={`flex items-center justify-center p-2.5 rounded hover:bg-border hover:text-primary ${
                      menu === "tracking" ? "bg-border text-primary" : "text-foreground"
                    }`}
                  >
                    <TbMap2 className="w-5 h-5" />
                  </div>
                </Tooltip>
              </button> */}
              {/* <button className="flex items-center justify-center p-0" onClick={() => handleClickMaintenance()}>
                <Tooltip content={t('repair_and_service')} delayDuration={50} side="right" sideOffset={10} className="bg-muted">
                  <div
                    className={`flex items-center justify-center p-2.5 rounded hover:bg-border hover:text-primary ${
                      menu === "repair_and_service" ? "bg-border text-primary" : "text-foreground"
                    }`}
                  >
                    <TbCalendarCog className="w-5 h-5" />
                  </div>
                </Tooltip>
              </button> */}
              <button aria-label={label('notifications')} className="flex items-center justify-center p-0" onClick={() => openDrawer("notifications")}>
                <Tooltip content={t('notifications')} delayDuration={50} side="right" sideOffset={10} className="bg-muted">
                  <div
                    className={`flex items-center justify-center p-2.5 rounded hover:bg-border hover:text-primary ${
                      menu === "notifications" ? "bg-border text-primary" : "text-foreground"
                    }`}
                  >
                    <TbNotification className="w-5 h-5" />
                  </div>
                </Tooltip>
              </button>
            </div>
            <Separator className="w-10 mx-auto"/>
            <div className="flex flex-col w-14 py-2 gap-2">
              <RoleRequire role="editor">
                <button aria-label={label('equipment')} className="flex items-center justify-center p-0" onClick={() => openDrawer("equipments")}>
                <Tooltip content={t('equipment')} delayDuration={50} side="right" sideOffset={10} className="bg-muted">
                  <div
                    className={`flex items-center justify-center p-2.5 rounded hover:bg-border hover:text-primary ${
                      menu === "equipments" ? "bg-border text-primary" : "text-foreground"
                    }`}
                  >
                    <TbBuildingWarehouse className="w-5 h-5" />
                  </div>
                </Tooltip>
                </button>
              </RoleRequire>
              <RoleRequire role="editor">
                <button aria-label={label('staff')} className="flex items-center justify-center p-0" onClick={() => openDrawer("personneles")}>
                <Tooltip content={t('staff')} delayDuration={50} side="right" sideOffset={10} className="bg-muted">
                  <div
                    className={`flex items-center justify-center p-2.5 rounded hover:bg-border hover:text-primary ${
                      menu === "personneles" ? "bg-border text-primary" : "text-foreground"
                    }`}
                  >
                    <TbUsersGroup className="w-5 h-5" />
                  </div>
                </Tooltip>
                </button>
              </RoleRequire>
              <RoleRequire role="maintainer">
                <button aria-label={label('devices')} className="flex items-center justify-center p-0" onClick={() => openDrawer("devices")}>
                  <Tooltip content={t('devices')} delayDuration={50} side="right" sideOffset={10} className="bg-muted">
                    <div
                      className={`flex items-center justify-center p-2.5 rounded hover:bg-border hover:text-primary ${
                        menu === "devices" ? "bg-border text-primary" : "text-foreground"
                      }`}
                    >
                      <TbCpu className="w-5 h-5" />
                    </div>
                  </Tooltip>
                </button>
              </RoleRequire>
              <RoleRequire role="maintainer">
                <button aria-label={label('dictonaries')} className="flex items-center justify-center p-0" onClick={() => openDrawer("directories")}>
                <Tooltip content={t('dictonaries')} delayDuration={50} side="right" sideOffset={10} className="bg-muted">
                  <div
                    className={`flex items-center justify-center p-2.5 rounded hover:bg-border hover:text-primary ${
                      menu === "dictonaries" ? "bg-border text-primary" : "text-foreground"
                    }`}
                  >
                    <TbBook2 className="w-5 h-5" />
                  </div>
                </Tooltip>
                </button>
              </RoleRequire>
            </div>
          </div>
          <div className="flex flex-col w-14 py-2 gap-2">
            <button aria-label={label('change_theme')} className="flex items-center justify-center p-0" onClick={() => changeTheme()}>
              <Tooltip content={t('change_theme')} delayDuration={50} side="right" sideOffset={10}  className="bg-muted">
                <div
                    className={`flex items-center justify-center p-2.5 rounded hover:bg-border hover:text-primary`}
                >
                  {store.theme == "dark" ? <TbBrightnessDown className="w-5 h-5" /> : <TbBrightnessUp className="w-5 h-5"/>}
                </div>
              </Tooltip>
            </button>
            <Popover>
              <PopoverTrigger asChild>
                <button aria-label={label('help')} className="flex items-center justify-center p-0">
                  <Tooltip content={t('help')} delayDuration={50} side="right" sideOffset={10} className="bg-muted">
                    <div
                      className={`flex items-center justify-center p-2.5 rounded hover:bg-border hover:text-primary ${
                        menu === "help" ? "bg-border text-primary" : "text-foreground"
                      }`}
                    >
                      <TbHelp className="w-5 h-5" />
                    </div>
                  </Tooltip>
                </button>
              </PopoverTrigger>
              <PopoverContent className="w-80" side="right" align="end" sideOffset={10}>
                <div className="grid gap-4">
                  <div className="space-y-2">
                    <h4 className="font-medium leading-none">{t('help')}</h4>
                    <p className="text-sm text-muted-foreground">
                      {t('help_desc')}
                    </p>
                  </div>
                </div>
              </PopoverContent>
            </Popover>

            <Popover>
              <RoleRequire role="maintainer">
                <PopoverTrigger asChild>
                <button aria-label={label('settings')} className="flex items-center justify-center p-0">
                  <Tooltip content={t('settings')} delayDuration={50} side="right" sideOffset={10} className="bg-muted">
                    <div
                      className={`flex items-center justify-center p-2.5 rounded hover:bg-border hover:text-primary ${
                        menu === "settings" ? "bg-border text-primary" : "text-foreground"
                      }`}
                    >
                      <TbSettings className="w-5 h-5" />
                    </div>
                  </Tooltip>
                </button>
              </PopoverTrigger>
              </RoleRequire>
              <PopoverContent className="w-80" side="right" align="end" sideOffset={10}>
                <div className="grid gap-4">
                  <div className="space-y-2">
                    <h4 className="font-medium leading-none">{t('company_settings')}</h4>
                    <p className="text-sm text-muted-foreground">
                      {t('company_settings_desc')}
                    </p>
                  </div>
                  <NavLink to={"/settings"} className="text-sm">{t('company_settings')}</NavLink>
                  <NavLink to={"/settings/participants"} className="text-sm">{t('participants')}</NavLink>
                  <NavLink to={"/settings/global_triggers"} className="text-sm">{t('global_triggers')}</NavLink>
                  <NavLink to={"/settings/apps"} className="text-sm">{t('apps')}</NavLink>
                  <NavLink to={"/settings/logs"} className="text-sm">{t('logs')}</NavLink>
                  <NavLink to={"/upload"} className="text-sm">Загрузка данных .log</NavLink>
                  <NavLink to={"/upload/log"} className="text-sm">Загрузка данных .gz</NavLink>
                </div>
              </PopoverContent>
            </Popover>

            <Popover>
              <PopoverTrigger asChild>
                <button aria-label={label('account')} className="flex items-center justify-center p-0">
                  <Tooltip content={t('account')} delayDuration={50} side="right" sideOffset={10} className="bg-muted">
                    <div
                      className={`flex items-center justify-center p-2.5 rounded hover:bg-border hover:text-primary ${
                        menu === "account" ? "bg-border text-primary" : "text-foreground"
                      }`}
                    >
                      <TbUser className="w-5 h-5" />
                    </div>
                  </Tooltip>
                </button>
              </PopoverTrigger>
              <PopoverContent className="w-80" side="right" align="end" sideOffset={10}>
                <div className="grid gap-4">
                  <div className="space-y-2">
                    <h4 className="font-medium leading-none">{t('account')}</h4>
                    <p className="text-sm text-muted-foreground">
                      {t('account_desc')}
                    </p>
                  </div>
                  <NavLink to={"/account"} className="text-sm">{t('account_settings')}</NavLink>
                  <NavLink to={"/organizations"} className="text-sm">{t('companies')}</NavLink>
                  <RoleRequire role="admin">
                    <NavLink to={"/admin"} className="text-sm">{t('administration')}</NavLink>
                  </RoleRequire>
                </div>
              </PopoverContent>
            </Popover>

            <button aria-label={label('logout')} className="flex items-center justify-center p-0" onClick={() => signout()}>
              <Tooltip content={t('logout')} delayDuration={50} side="right" sideOffset={10} className="bg-muted">
                <div
                  className={`p-1.5 rounded hover:bg-blueA9 hover:text-white ${
                    menu === "logout" ? "bg-blueA5 text-blue-600" : "text-slate-800 dark:text-white"
                  }`}
                >
                  <TbLogout2 className="w-5 h-5" />
                </div>
              </Tooltip>
            </button>
          </div>
        </div>
      </div>
      <Separator orientation="vertical" className="z-20"/>
      <Transition show={openMenu} appear={true}>
        <div className="z-10">
          <TransitionChild>
            <div
              className="fixed inset-0 bg-slate-950/60 left-14 transition ease-in data-[closed]:opacity-0 backdrop-blur-sm"
              onClick={() => closeDrawer()}
            />
          </TransitionChild>
          <TransitionChild>
            <div className="fixed flex flex-col inset-y-0 bg-background left-14 w-[768px] border-r transition duration-100 data-[closed]:-translate-x-full">
              {getMenuContent(menu)}
            </div>
          </TransitionChild>
        </div>
      </Transition>
    </>
  );
};
